// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "reactPlayerPreview" + "." + "7236e96e57029cde8604" + ".js";
};